import { ConnectionStatusT } from './api';

export interface SourcesResultT {
  id: string;
  name: string;
  source: string;
  connectorType: string;
  technology: string;
  status: boolean;
  timeout: number;
  apiKey: string;
  username: string;
  password: string;
  crt: string;
  organization: string;
  //
  createdBy: string;
  createdAt: string;
  lastUpdated: string;
  //
  statusReportedAt: string | null;
  uplinkStatus: ConnectionStatusT;
  downlinkStatus: ConnectionStatusT;
  //
  mtuTxLink: number;
  useDefaultMtu: boolean;
}

// ValidateDeviceIDByTechnology in acklio-ipcore-api/ipcorecdp/device_config.go
// eslint-disable-next-line no-unused-vars
export const SOURCE_TECHNOLOGY_SIGFOX: string = 'SIGFOX';
// eslint-disable-next-line no-unused-vars
export const SOURCE_TECHNOLOGY_LORAWAN: string = 'LORAWAN';

export type DeviceIDRequirementT = {
  regex?: RegExp;
  regexHelper?: string;
  defaultHelper?: string;
}
export const DeviceIDRequirement: Record<string, DeviceIDRequirementT> = {
  LORAWAN: {
    regex: /^[0-9A-Fa-f]{16}$/i,
    regexHelper: 'Must follow the LORAWAN pattern - 0-9, A-F, a-f and contains 16 characters',
    defaultHelper: 'LoRaWAN device EUI (ex: "c764b13e43a765f1")',
  },
  SIGFOX: {
    regex: /^[0-9A-Fa-f]{1,8}$/i,
    regexHelper: 'Must follow the SIGFOX pattern - 0-9, A-F, a-f and contains between 1 and 8 characters',
    defaultHelper: 'SIGFOX ID (ex: "43a765f1")',
  },
  DEFAULT: {
    defaultHelper: 'Device ID',
  },
};

export const getDeviceIDRequirement = (technology: string): DeviceIDRequirementT => {
  const requirements = DeviceIDRequirement[technology];
  if (!requirements) {
    return DeviceIDRequirement.DEFAULT;
  }
  return requirements;
};
